import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import MentionFormat from './MentionFormat';
import UserMention from '../UserMention';
import PostMention from '../PostMention';
import GroupMention from '../GroupMention';
export default class AtMentionFormat extends MentionFormat {
  constructor() {
    super(...arguments);
    _defineProperty(this, "mentionables", [UserMention, PostMention, GroupMention]);
    _defineProperty(this, "extendable", true);
  }
  trigger() {
    return '@';
  }
  queryFromTyped(typed) {
    const matchTyped = typed.match(/^["“]?((?:(?!"#).)+)$/);
    return matchTyped ? matchTyped[1] : null;
  }
  format(name, char, id) {
    if (char === void 0) {
      char = '';
    }
    if (id === void 0) {
      id = null;
    }
    return {
      simple: "@".concat(name),
      safe: "@\"".concat(name, "\"#").concat(char).concat(id)
    }[id ? 'safe' : 'simple'];
  }
}
flarum.reg.add('flarum-mentions', 'forum/mentionables/formats/AtMentionFormat', AtMentionFormat);